import { render } from "./UnitMeasure.vue?vue&type=template&id=11f79768"
import script from "./UnitMeasure.vue?vue&type=script&lang=js"
export * from "./UnitMeasure.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__